import { render, staticRenderFns } from "./shopify_order_page.vue?vue&type=template&id=7538c5b4&"
import script from "./shopify_order_page.vue?vue&type=script&lang=js&"
export * from "./shopify_order_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports